import {addressLabel,findPlacement,parseStorageScan} from './storageModel.mjs';

export function locationText(location){
 const box=parseStorageScan(location?.boxCode);
 return box?addressLabel({code:box.boxCode,safe_number:box.safe,row_number:box.row,box_number:box.box},location.side,location.position):'No saved location';
}
export function scanOrigin(state,cert,boxCode,side){
 const place=findPlacement(state,cert);
 if(!place||place.box.code===boxCode&&place.side===side)return null;
 return {boxCode:place.box.code,side:place.side,position:place.position};
}
export function plannedMovements(state,command){
 if(command.operation!=='census')return [];
 return ['L','R'].flatMap(side=>(side==='L'?command.leftCerts:command.rightCerts).flatMap((cert,index)=>{
  const p=findPlacement(state,cert),to={boxCode:command.boxCode,side,position:index+1};
  const from=p?{boxCode:p.box.code,side:p.side,position:p.position}:null;
  if(from&&from.boxCode===to.boxCode&&from.side===to.side&&from.position===to.position)return [];
  return [{cert,from,to}];
 }));
}
// Read the database's actual before/after receipt, not a stale UI prediction.
// Include target-box changes only; source-gap compaction is already automatic.
export function savedMovements(receipt,command){
 if(command.operation!=='census'||!receipt?.saved)return [];
 const before=new Map((receipt.before?.positions||[]).map(p=>[p.slab_id,p]));
 return (receipt.after?.positions||[]).filter(p=>p.box_code===command.boxCode).flatMap(p=>{
  const cert=(p.side==='L'?command.leftCerts:command.rightCerts)?.[p.position-1];
  if(!cert)return [];
  const prior=before.get(p.slab_id);
  if(prior&&prior.box_code===p.box_code&&prior.side===p.side&&prior.position===p.position)return [];
  const project=p=>({boxCode:p.box_code,side:p.side,position:p.position});
  return [{cert,from:prior?project(prior):null,to:project(p)}];
 }).sort((a,b)=>a.to.side.localeCompare(b.to.side)||a.to.position-b.to.position);
}
